import Router from './routes';

// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';

import useAuth from './hooks/useAuth';
import NotistackProvider from './components/NotistackProvider';
import ThemeLocalization from './components/ThemeLocalization';
// components
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen, { ProgressBarStyle } from './components/LoadingScreen';
import { CommonProvider } from './contexts/CommonContext';

function App() {
  const { isInitialized = true } = useAuth();

  return (
    <ThemeConfig>
      <ThemeLocalization>
        <ScrollToTop />
        <NotistackProvider>
          <GlobalStyles />
          <ProgressBarStyle />
          <CommonProvider>
            {/* <Container maxWidth="xs" sx={{ p: 0 }}> */}
            {isInitialized ? <Router /> : <LoadingScreen />}
            {/* </Container> */}
          </CommonProvider>
        </NotistackProvider>
      </ThemeLocalization>
    </ThemeConfig>
  );
}

export default App;
